import { captureException, captureMessage } from '@sentry/react';

export type ErrorInfo = Record<string, unknown>;

type Monitoring = {
  /**
   * Sends an 'Issue' to Sentry with level 'Error';
   * Use for monitoring purposes.
   */
  noticeError: (error: Error, info?: ErrorInfo) => void;
  /**
   * Sends an 'Info' to Sentry with level 'Info';
   * Use for monitoring purposes when the error is not an issue.
   */
  noticeErrorAsInfo: (error: Error, info?: ErrorInfo) => void;
};

export const useMonitoring = (): Monitoring => {
  const noticeError = (error: Error, info?: ErrorInfo) => {
    captureException(error, {
      extra: info,
    });
  };

  const noticeErrorAsInfo = (error: Error, info?: ErrorInfo) => {
    captureMessage(error.message, {
      level: 'info',
      extra: {
        ...info,
        originalMessage: error.message,
        originalError: error,
      },
    });
  };

  return {
    noticeError,
    noticeErrorAsInfo,
  };
};
